(function () {
  if (window.woProductMobileBuy) {
    window.woProductMobileBuy.refresh();
    return;
  }

  const anchorSelector = '[data-wo-mobile-buy-anchor]';
  const articleSelector = 'article.wo-product-enhanced[data-form-id][data-product-id]';
  const ownedSelector = '[data-wo-mobile-buy], [data-wo-mobile-buy-space]';
  const instances = new Map();
  const unloaded = new WeakSet();
  const media = window.matchMedia('(max-width: 760px)');
  let frame = 0;

  function visible(element) {
    if (!element) return false;
    const rect = element.getBoundingClientRect();
    const style = window.getComputedStyle(element);
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight && style.visibility !== 'hidden' && style.display !== 'none';
  }

  function findArticle(anchor) {
    const section = anchor.closest('.shopify-section') || anchor.parentElement;
    return section && Array.from(section.querySelectorAll(articleSelector)).find(function (article) {
      return article.dataset.productId === anchor.dataset.productId && article.dataset.template === anchor.dataset.sectionId;
    });
  }

  function findForm(article) {
    return article && Array.from(article.querySelectorAll('form')).find(function (form) {
      return form.getAttribute('id') === article.dataset.formId;
    });
  }

  function hide(instance) {
    if (!instance.bar.hidden) instance.bar.hidden = true;
    if (instance.spacer.style.height !== '0px') instance.spacer.style.height = '0px';
  }

  function dispose(instance) {
    hide(instance);
    instance.resize.disconnect();
    instance.choice.removeEventListener('click', instance.changeOptions);
    instance.submit.removeEventListener('click', instance.checkSubmit);
    if (instance.anchor.isConnected) {
      instance.anchor.appendChild(instance.bar);
      instance.anchor.appendChild(instance.spacer);
    } else {
      instance.bar.remove();
      instance.spacer.remove();
    }
    instances.delete(instance.anchor);
  }

  function controlLabel(control) {
    if (control.tagName === 'SELECT') {
      const option = control.options[control.selectedIndex];
      return option ? option.textContent.trim() : '';
    }
    const label = Array.from(control.labels || []).find(function (item) { return item.textContent.trim(); });
    return label ? label.textContent.trim() : (control.title || control.value || '').trim();
  }

  function selection(instance, article, form) {
    const group = article.querySelector('.f8pr-variant-selection');
    if (!group || instance.anchor.dataset.defaultVariant === 'true') return { text: '', control: null };
    const controls = Array.from(group.querySelectorAll('input[type="radio"], select')).filter(function (control) {
      return control.form === form && (control.name === 'variant-id' || control.name.startsWith('options['));
    });
    const selected = controls.filter(function (control) {
      return control.tagName === 'SELECT' || control.checked;
    });
    const options = selected.filter(function (control) { return control.name.startsWith('options['); });
    const chosen = options.length ? options : selected.filter(function (control) { return control.name === 'variant-id'; }).slice(0, 1);
    const text = chosen.map(function (control) {
      const namedGroup = control.closest('[data-wo-option-name]');
      let name = namedGroup ? namedGroup.dataset.woOptionName : '';
      if (!name && control.name.startsWith('options[')) {
        name = control.name.slice(8, -1);
        const prefix = instance.anchor.dataset.sectionId + '-';
        if (name.startsWith(prefix)) name = name.slice(prefix.length);
      } else if (!name && instance.optionNames.length === 1) {
        name = instance.optionNames[0];
      }
      if (control.name === 'variant-id' && instance.optionNames.length > 1) name = '';
      const value = controlLabel(control);
      return value ? (name ? name + ' : ' : '') + value : '';
    }).filter(Boolean).join(' · ');
    const control = chosen.concat(controls).find(function (item) {
      return !item.disabled && !item.closest('[hidden], .hidden, .js-hidden');
    });
    return { text: text, control: control, group: group };
  }

  function update(instance) {
    const article = findArticle(instance.anchor);
    const form = findForm(article);
    const mainButton = form && form.querySelector('button[type="submit"]');
    if (!article || !form || !mainButton) {
      instance.submit.disabled = true;
      hide(instance);
      return;
    }
    const formId = form.getAttribute('id');
    if (instance.submit.getAttribute('form') !== formId) instance.submit.setAttribute('form', formId);
    const mainPrice = article.querySelector('.f8pr-price');
    if (mainPrice && instance.price.innerHTML !== mainPrice.innerHTML) instance.price.innerHTML = mainPrice.innerHTML;
    const selected = selection(instance, article, form);
    const hasChoice = Boolean(selected.control && selected.text);
    if (instance.choice.hidden === hasChoice) instance.choice.hidden = !hasChoice;
    if (instance.choice.textContent !== selected.text) instance.choice.textContent = selected.text;
    const choiceName = selected.text + '. ' + instance.choice.dataset.changeLabel;
    if (instance.choice.getAttribute('aria-label') !== choiceName) instance.choice.setAttribute('aria-label', choiceName);

    const variant = form.querySelector('input[name="id"], select[name="id"]');
    const processing = form.classList.contains('processing');
    const unavailable = !variant || variant.disabled || !variant.value || mainButton.matches(':disabled') || mainButton.classList.contains('disabled') || mainButton.getAttribute('aria-disabled') === 'true' || form.classList.contains('unavailable') || Boolean(mainButton.closest('.unavailable'));
    const disabled = processing || unavailable;
    if (instance.submit.disabled !== disabled) instance.submit.disabled = disabled;
    const buttonText = mainButton.textContent.trim();
    if (instance.submit.textContent !== buttonText) instance.submit.textContent = buttonText;
    if (instance.submit.getAttribute('aria-busy') !== String(processing)) instance.submit.setAttribute('aria-busy', String(processing));

    const overlay = Array.from(document.querySelectorAll('.popup-a.shown, .fancybox__container, dialog[open], [role="dialog"][aria-modal="true"], .m6pn.shown')).some(visible);
    const cookie = document.documentElement.classList.contains('cookie-on') && !document.documentElement.classList.contains('cookie-toggle');
    const preview = document.getElementById('PBarNextFrameWrapper');
    const previewOffset = visible(preview) ? Math.ceil(preview.getBoundingClientRect().height) : 0;
    const offsetValue = previewOffset + 'px';
    if (instance.bar.style.getPropertyValue('--wo-preview-offset') !== offsetValue) instance.bar.style.setProperty('--wo-preview-offset', offsetValue);
    if (!media.matches || overlay || cookie || !mainButton.getClientRects().length || mainButton.getBoundingClientRect().bottom > 0) {
      hide(instance);
      return;
    }
    if (instance.bar.hidden) instance.bar.hidden = false;
    const space = Math.ceil(instance.bar.getBoundingClientRect().height + previewOffset) + 'px';
    if (instance.spacer.style.height !== space) instance.spacer.style.height = space;
  }

  function mount(anchor) {
    const bar = anchor.querySelector('[data-wo-mobile-buy]');
    const spacer = anchor.querySelector('[data-wo-mobile-buy-space]');
    if (!bar || !spacer) return;
    const instance = {
      anchor: anchor,
      bar: bar,
      spacer: spacer,
      price: bar.querySelector('.wo-mobile-buy-price'),
      choice: bar.querySelector('.wo-mobile-buy-size'),
      submit: bar.querySelector('.wo-mobile-buy-submit'),
      optionNames: []
    };
    if (!instance.price || !instance.choice || !instance.submit) return;
    try { instance.optionNames = JSON.parse(anchor.dataset.optionNames || '[]'); } catch (error) { instance.optionNames = []; }
    if (!Array.isArray(instance.optionNames)) instance.optionNames = [];
    instance.changeOptions = function () {
      const article = findArticle(anchor);
      const form = findForm(article);
      if (!article || !form) return;
      const selected = selection(instance, article, form);
      if (!selected.control) return;
      selected.group.scrollIntoView({ block: 'center', behavior: 'auto' });
      selected.control.focus({ preventScroll: true });
      schedule();
    };
    instance.checkSubmit = function (event) {
      update(instance);
      if (instance.submit.disabled) event.preventDefault();
    };
    instance.choice.addEventListener('click', instance.changeOptions);
    instance.submit.addEventListener('click', instance.checkSubmit);
    instance.resize = new ResizeObserver(schedule);
    instance.resize.observe(bar);
    instances.set(anchor, instance);
    (document.getElementById('root') || document.body).appendChild(bar);
    document.body.appendChild(spacer);
  }

  function refresh() {
    frame = 0;
    instances.forEach(function (instance, anchor) {
      if (!anchor.isConnected || unloaded.has(anchor)) {
        dispose(instance);
      } else {
        if (!instance.bar.isConnected) (document.getElementById('root') || document.body).appendChild(instance.bar);
        if (!instance.spacer.isConnected) document.body.appendChild(instance.spacer);
      }
    });
    const anchors = new Map();
    document.querySelectorAll(anchorSelector).forEach(function (anchor) {
      if (!unloaded.has(anchor)) anchors.set(anchor.dataset.sectionId + ':' + anchor.dataset.productId, anchor);
    });
    instances.forEach(function (instance, anchor) {
      if (anchors.get(anchor.dataset.sectionId + ':' + anchor.dataset.productId) !== anchor) dispose(instance);
    });
    anchors.forEach(function (anchor) {
      if (!instances.has(anchor)) mount(anchor);
    });
    instances.forEach(update);
  }

  function schedule() {
    if (!frame) frame = window.requestAnimationFrame(refresh);
  }

  window.woProductMobileBuy = { refresh: schedule };
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('themeVariantUpdated', schedule);
  document.addEventListener('change', schedule);
  document.addEventListener('input', schedule);
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target instanceof Element) event.target.querySelectorAll(anchorSelector).forEach(function (anchor) { unloaded.delete(anchor); });
    schedule();
  });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (instance, anchor) {
      if (event.target instanceof Element && event.target.contains(anchor)) {
        unloaded.add(anchor);
        dispose(instance);
      }
    });
    schedule();
  });
  media.addEventListener('change', schedule);
  new MutationObserver(function (records) {
    if (records.some(function (record) {
      const target = record.target instanceof Element ? record.target : record.target.parentElement;
      return target && !target.closest(ownedSelector);
    })) schedule();
  }).observe(document.documentElement, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'disabled', 'aria-disabled', 'aria-hidden', 'open', 'value', 'checked', 'selected', 'data-form-id', 'data-product-id'] });
  schedule();
})();
